import { html } from '@crossiety/lit-components';
import BaseMenu from '@crossiety/lit-components/components/base_menu/element.js';
import '@crossiety/lit-components/components/dot_menu/element.js';
import '@crossiety/lit-components/components/icon/element.js';

import style from './style.lit.css';

/**
 * Dropdown menu for switching the language
 *
 * @prop locales - An array of available locales - `[{name, url}, ...]`
 * @prop currentLocale - Name of the currently selected locale
 *
 * @cssprop [--trigger-height: auto] Height of the trigger button
 * @cssprop [--trigger-bg: var(--primary-600)] Background color of the trigger button
 * @cssprop [--trigger-hover-bg: var(--primary-700)] Background color of the hovered trigger button
 * @cssprop [--trigger-active-bg: var(--primary-600)] Background color of the active trigger button
 * @cssprop [--trigger-hover-text: var(--yellow-400)] Text color of the hovered trigger button
 * @cssprop [--trigger-font-size: var(--font-size-sm)] Font size of the trigger button
 * @cssprop [--trigger-padding: 2px 8px 4px] Padding of the trigger button
 */

export default class LanguageSwitcherMenu extends BaseMenu {
  static styles = [BaseMenu.styles, style];

  static properties = {
    locales: { type: Array },
    currentLocale: { type: String },
  };

  /** @internal */
  itemConfigForLocale = ({ name, url }) => {
    return {
      title: name,
      icon: 'none', // prevents console errors, because all other menu items have icons
      action: {
        menu: 'xs-language-switcher-menu',
        id: this.instanceId,
        method: 'visit',
        args: [url],
      },
      partName: `language ${
        this.currentLocale === name ? 'dot-item-active' : ''
      }`,
    };
  };

  /** @internal */
  get instanceId() {
    return 'language-switcher';
  }

  /** @internal */
  get items() {
    return this.locales.map(this.itemConfigForLocale);
  }

  /** @internal */
  get dotMenuConfig() {
    return {
      buttons: this.items,
      showCancel: true,
    };
  }

  visit(url) {
    return this.commonActions.visit(url);
  }

  render() {
    return html`
      <ef-dot-menu .config=${this.dotMenuConfig}>
        <button class="xs-btn btn-naked-contrast-light" slot="trigger">
          <ef-icon name="globe"></ef-icon>
          <span>${this.currentLocale}</span>
        </button>
      </ef-dot-menu>
    `;
  }
}

LanguageSwitcherMenu.registerTagName('xs-language-switcher-menu');
LanguageSwitcherMenu.registerCommonActions('xs-language-switcher-menu');

customElements.get('xs-language-switcher-menu') ||
  customElements.define('xs-language-switcher-menu', LanguageSwitcherMenu);
